module.exports = __webpack_public_path__ + "img/icn_consulting@3x.3daef61e.png";